/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';
/**
 * Utility module for logic and settings related to using cookies with site settings
 */

const commonModule = require('@utils/common/commonModule');
const CookiesService = require('./cookiesService');
const UserConsentAlertDirective = require('./userConsentAlert/userConsentAlertDirective');

const cookiesModule = angular
    .module('enervee_utils.cookies', [
        commonModule.name,
    ])
    .factory('CookiesService', CookiesService)
    .directive('userConsentAlert', UserConsentAlertDirective);

module.exports = cookiesModule;
